import BaseConfig from './BaseConfig';

/**
 * @private
 * @author chen yu
 * @date 07/01/2021 01:01:55
 * @class
 * @extends {BaseConfig}
 */
class ConrolConfig extends BaseConfig {

    constructor(options = {}) {

        super(options);
        this.Name = options.Name;

        this.ColInfo = options.ColInfo || {};

        this.Visible = true;
        
    }

    Export() {
        return {
            ...super.Export(),
            Name: this.Name
        };
    }

    GetPositionInfo() {
        return this.PositionInfo;
    }

    GetLayoutInfo() {
        return { Name: this.Name, PositionInfo: this.GetPositionInfo() };
    }
}

export default ConrolConfig;